import { createContext, useContext, useRef, useState } from "react";

const AudioCtx = createContext(null);

export function AudioProvider({ children }) {
  const audioRef = useRef(null);
  const [track, setTrack] = useState(null);
  const [playing, setPlaying] = useState(false);

  const playTrack = (t) => {
    if (track?.url === t.url) {
      toggle();
      return;
    }
    setTrack(t);
    setPlaying(true);
    setTimeout(() => audioRef.current?.play().catch(() => {}), 60);
  };

  const toggle = () => {
    const a = audioRef.current;
    if (!a || !track) return;
    if (a.paused) {
      a.play().catch(() => {});
      setPlaying(true);
    } else {
      a.pause();
      setPlaying(false);
    }
  };

  const close = () => {
    audioRef.current?.pause();
    setTrack(null);
    setPlaying(false);
  };

  return (
    <AudioCtx.Provider value={{ track, playing, playTrack, toggle, close, audioRef, setPlaying }}>
      {children}
    </AudioCtx.Provider>
  );
}

export const useAudio = () => useContext(AudioCtx);
